import reqwest from 'reqwest'

export default {

  formsDisabledOnSubmit: document.querySelectorAll('.js-form-disable-onsubmit'),
  formsDiscount: document.querySelectorAll('.js-form-discount'),

  initFormDisabledOnSubmit: function (form) {
    form.addEventListener('submit', (e) => {
      const submits = form.querySelectorAll('button[type="submit"]')
      submits.forEach((submit) => {
        submit.setAttribute('disabled', 'true')
      })
    })
  },

  initFormDiscount: function (form) {
    form.addEventListener('submit', (e) => {
      if (!form.hasAttribute('valid')) {
        const name = form.querySelector('input[name="name"]').value
        const surname = form.querySelector('input[name="surname"]').value
        const email = form.querySelector('input[name="email"]').value
        const password = form.querySelector('input[name="password"]').value
        const passwordConfirmation = form.querySelector('input[name="password_confirmation"]').value
        const privacy = form.querySelector('input[name="privacy"]').value

        if ((password && password.length > 0) || (passwordConfirmation && passwordConfirmation.length > 0)) {
          e.preventDefault()

          const signup = form.getAttribute('data-signup')
          reqwest({
            url: signup,
            method: 'post',
            data: {
              name,
              surname,
              email,
              privacy,
              password,
              password_confirmation: passwordConfirmation
            },
            success: (response) => {
              const errorEmailUsed = !response.result && response.errors.length == 1 && response.errors[0].code == 'email_used'

              if (response.result || errorEmailUsed) {
                form.setAttribute('valid', 'true')
                form.submit()
              } else {
                alert(response.errors[0].message)
              }
            },
          })
        }
      }
    })
  },

  init: function () {
    this.formsDisabledOnSubmit.forEach((form) => {
      this.initFormDisabledOnSubmit(form)
    })

    this.formsDiscount.forEach((form) => {
      this.initFormDiscount(form)
    })
  }
}


// WEBPACK FOOTER //
// app/javascript/scripts/components/Form.js